let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2ZYfI")).then(() => parcelRequire('b8JQ4'));